import { render } from "./NetworkTest.vue?vue&type=template&id=d996362e&scoped=true"
import script from "./NetworkTest.vue?vue&type=script&lang=js"
export * from "./NetworkTest.vue?vue&type=script&lang=js"

import "./NetworkTest.vue?vue&type=style&index=0&id=d996362e&scoped=true&lang=css"

import exportComponent from "/home/runner/work/vertex/vertex/webui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d996362e"]])

export default __exports__